import React, {FC} from 'react';

import {TeamModel} from '../../../../../libs/shared/core/src/models/api/teamModel';
import {InboxesPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {WorkspaceDragSourceTypesEnum, WorkspaceItemDropHandler} from '../dnd/workspaceDragDropTypes';
import {WorkspaceInboxItemContainer} from '../workspaceInboxItemContainer';
import {WorkspaceTeamItemContainer} from '../workspaceTeamItemContainer';
import {ToggleTeamInboxHandler} from './context/types';
import {SelectableInbox} from './teamWorkspaceEditorInboxesContainer';

/*
 * Constants.
 */

const indentLevelWithHeader = 1;

/*
 * Props.
 */

interface TeamWorkspaceEditorInboxesProps {
  panelId: InboxesPanelId;
  team: TeamModel;
  inboxes: ReadonlyArray<SelectableInbox>;
  isExpanded: boolean;
  isAlphabetized: boolean;
  onToggle: ToggleTeamInboxHandler;
  onToggleExpandClick: () => void;
  onWorkspaceItemDrop: WorkspaceItemDropHandler;
}

/*
 * Component.
 */

export const TeamWorkspaceEditorInboxes: FC<TeamWorkspaceEditorInboxesProps> = (props) => {
  const {panelId, team, isExpanded, onToggleExpandClick, isAlphabetized} = props;

  return (
    <>
      {/* Aggregate view. */}
      <WorkspaceTeamItemContainer
        panelId={panelId}
        team={team}
        isExpanded={isExpanded}
        onToggleExpandClick={onToggleExpandClick}
        shouldAlphabetizeWorkspace={isAlphabetized}
        selectedRefinement={undefined}
        isEditingWorkspace
        shouldHideMoreMenu
      />

      {/* Inboxes. */}
      {maybeRenderExpandedContent(props)}
    </>
  );
};

function maybeRenderExpandedContent(props: TeamWorkspaceEditorInboxesProps) {
  const {panelId, isExpanded, inboxes, onToggle, onWorkspaceItemDrop, team} = props;
  if (!isExpanded) {
    return null;
  }

  const lastIndex = inboxes.length - 1;

  return (
    <>
      {/* Inboxes. */}
      {inboxes.map((inboxItem, index) => (
        <WorkspaceInboxItemContainer
          shouldAlphabetizeWorkspace={false}
          shouldShowRefinedResultsIndicator={false}
          canBeHidden
          shouldHideMoreMenu
          key={inboxItem.inbox.id}
          panelId={panelId}
          inbox={inboxItem.inbox}
          indentLevel={indentLevelWithHeader}
          isChecked={inboxItem.isSelected}
          onClick={() => onToggle({id: inboxItem.inbox.id, teamId: team.id}, false)}
          onWorkspaceItemDrop={onWorkspaceItemDrop}
          workspaceDragItem={{
            type: WorkspaceDragSourceTypesEnum.TEAM_INBOX,
            namespace: inboxItem.inbox.namespace,
            id: inboxItem.inbox.id,
            isLast: index === lastIndex,
          }}
          isEditingWorkspace
          hasEditPermission={false}
          isRecentlyViewed={inboxItem.isRecentlyViewed}
          selectedRefinement={undefined}
        />
      ))}
    </>
  );
}
